'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoLightBulb = function GoLightBulb(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 2.5c-6.9 0-12.5 5.6-12.5 12.5 0 4.1 2 7.7 5 10v7.5c0 1.4 1.1 2.5 2.5 2.5 0 1.4 1.1 2.5 2.5 2.5h5c1.4 0 2.5-1.1 2.5-2.5 1.4 0 2.5-1.1 2.5-2.5v-7.5c3-2.3 5-5.9 5-10 0-6.9-5.6-12.5-12.5-12.5z m5 28.8c0 0.6-0.6 1.2-1.2 1.2h-7.5c-0.7 0-1.3-0.6-1.3-1.2v-1.3h10v1.3z m2.5-9.7c-1.3 1.3-2.5 1.7-2.5 4.9v1h-2.5v-5l5-5v-2.5l-2.5-2.5-2.5 2.5-2.5-2.5-2.5 2.5-2.5-2.5-2.5 2.5v2.5l5 5v5h-2.5v-1c0-3.2-1.2-3.6-2.5-4.9-1.6-1.7-2.5-4.1-2.5-6.6 0-5.5 4.5-10 10-10s10 4.5 10 10c0 2.5-0.9 4.9-2.5 6.6z m-7.5 0.9l-5-5v-2.5l2.5 2.5 2.5-2.5 2.5 2.5 2.5-2.5v2.5l-5 5z' })
        )
    );
};

exports.default = GoLightBulb;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/light-bulb.js
// module id = 1716
// module chunks = 0